import React from 'react';
import useDataLoader2 from '../../hooks/useDataLoader2';
import CatalogTableC from '../../components/Catalogs/CatalogTableC';
import PaginatedTable from '../../components/Organismos/Table/PaginatedTable';
import ShapeEdit from '../../components/Atomos/Icons/ShapeEdit';
import SvgIcon from '../../components/ViewMode/IconComponent';
import { defaultPageSize } from '../../utils/const';
import Filters, { IFilterData } from '../../components/Catalogs/Filters/Filters';
import PersistentLink from '../../components/Moleculas/PersistentLink';
import { IPracticeIndustry } from '../../interfaces/models/IPracticeIndustry';
import { formatDateToString } from '../../utils/functions';
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const PracticeIndustry: React.FC = ({ ...props }) => {
  const fields = [
    'id', 
    'legacyId',
    'name', 
    'icon',
    'createdAt'
  ]
  const endpoint = '/practiceIndustry';
  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    filter,
    inputFilters,
    setInputFilters
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "name", order: "asc" },
  });

  const columnsDef = React.useMemo(() => [
    {
      id: "count",
      header: "#",
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p> {rowIndex + 1 + pagination.pageIndex * pagination.pageSize} </p>
      ),
    },
    { id: 'name', header: 'Name' },
    { 
      id: 'icon', 
      header: 'Icon', 
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <div className="flex w-8 h-8 lg:w-10 lg:h-10 items-center justify-center">
          <SvgIcon 
            practiceId={row.id} 
            practiceName={row.name} 
            iconUrl={data.find((p: any) => p.id === row.id)?.icon} 
          />
        </div> 
      )
    },
    { id: 'createdAt', header: "Created Date" },
    {
      id: 'edit',
      header: 'Edit',
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={row}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit{" "}
          <div className="editsvg">
            <ShapeEdit />
          </div>{" "}
        </PersistentLink>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters, data]);

  const formatData = (data: IPracticeIndustry[]) => {
    const formatedData = data.map(d => {
      return {
        ...d,
        createdAt: d.createdAt ? formatDateToString(new Date( d.createdAt)) : ''
      }
    })
    return formatedData
  }

  const filtersData: IFilterData[] =  [
    {
      name: "Name",
      type: "text",
      comparison: "CONTAINS",
    },
  ]
  
  return (
    <>
        <CatalogTableC
          title={`Practice Industry Catalog`}
          catalogName={'PRACTICE INDUSTRIES'}
          catalogShortName='Practice Industry'
          route={'PracticeIndustry'}
          totalCount={totalCount}
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
                fields,
              })
            }
          />
        </CatalogTableC>
    </>
  );
};

export default PracticeIndustry;